import { ComponentProps } from 'react';

import { Spinner } from '../../display/Spinner';
import { LegacyButton } from '../LegacyButton';
import styles from './LoadMoreBar.module.scss';

type Props = {
  /**
   * Text that is rendered within the bar. This is intentionally typed as a
   * `string` to discourage injection of arbitrary React elements.
   * This component is for rendering _text_.
   */
  children: string;
  /**
   * Indicates if the content this bar refers to is currently loading.
   * Triggers the rendering of a loading indicator.
   */
  isLoading: boolean;
  /** Callback to be executed when the bar is clicked. */
  onClick?: ComponentProps<typeof LegacyButton>['onClick'];
  /** Size of the load more button to render. */
  size?: ComponentProps<typeof LegacyButton>['size'];
};

/** `LoadMoreBar` is used when pagination is present to load more items. */
export const LoadMoreBar = (props: Props) => {
  const { children, isLoading, onClick, size } = props;
  const spinner = (
    <span className={styles.spinner} data-zds>
      <Spinner color="dark" aria-label="Loading icon" />
      Loading
    </span>
  );
  return (
    <LegacyButton
      color="secondary"
      disabled={isLoading}
      isFullWidth={true}
      onClick={onClick}
      size={size}
    >
      {isLoading ? spinner : children}
    </LegacyButton>
  );
};
